module.exports = __webpack_public_path__ + "img/icon_shuzipuhui.8952520c.svg";